import { z } from 'zod';
import { InterviewOwner, InterviewsStatus } from '@axiom/const';
import { ZodArrayToEnum } from '@axiom/types';

const interviewOwnerKeys = Object.keys(InterviewOwner);

const interviewStatusValues = ['all', ...Object.values(InterviewsStatus)];

export const WorkspaceInterviewsFormSchema = z.object({
  FILTER_BY_OWNER: z.enum(ZodArrayToEnum(interviewOwnerKeys)).nullable(),
  FILTER_BY_STATUS: z.enum(ZodArrayToEnum(interviewStatusValues)).nullable(),
});

export type WorkspaceInterviewsType = z.infer<
  typeof WorkspaceInterviewsFormSchema
>;
